import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import GridSlants from './GridSlants'
import './SlantBackground.scss'

export function SlantBackground({
  children,
  slantRight = false,
  shallowSlant = false,
  verticalOffset = 0,
}) {
  // By default, the CSS for GridSlants is to the left so that's
  // why we have a boolean that has to be turned on to make it
  // to the right

  return (
    <div
      className={classnames('slant-background', {
        'slant-background-right': slantRight,
        'slant-background-left': !slantRight,
        'shallow-slant': shallowSlant,
      })}>
      <GridSlants style={{ top: `${verticalOffset}rem` }}>
        <div className="slant-background-main-cell" />
        {children}
      </GridSlants>
    </div>
  )
}

SlantBackground.propTypes = {
  verticalOffset: PropTypes.number,
  slantRight: PropTypes.bool,
}

export function SlantBackgroundImage({ src, ...props }) {
  return (
    <div className="slant-background-image">
      <div className="img" {...props} style={{ backgroundImage: `url(${src})` }} />
    </div>
  )
}
